/* <gr-marquee> — seamless horizontal ticker.
   The track is duplicated in Liquid so the CSS animation can translate -50%
   and loop without a visible seam. This element only handles the parts Liquid
   cannot: applying the duration, and honouring reduced motion by degrading to
   a plain scrollable row rather than freezing content mid-slide. */

class GrMarquee extends HTMLElement {
  connectedCallback() {
    if (this._bound) return;
    this._bound = true;

    this.track = this.querySelector('[data-marquee-track]');
    this.media = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.apply = this.apply.bind(this);

    this.apply();
    // addEventListener over addListener; removed again on disconnect.
    this.media.addEventListener('change', this.apply);
  }

  disconnectedCallback() {
    if (this.media) this.media.removeEventListener('change', this.apply);
    this._bound = false;
  }

  apply() {
    if (!this.track) return;

    if (this.media.matches) {
      this.track.style.animation = 'none';
      this.track.style.width = 'auto';
      this.setAttribute('data-static', '');
      return;
    }

    this.removeAttribute('data-static');
    this.track.style.width = '';
    const seconds = Number(this.getAttribute('data-speed')) || 78;
    this.track.style.animationDuration = seconds + 's';
    // will-change only while the animation is actually running.
    this.track.style.willChange = 'transform';
  }
}

if (!customElements.get('gr-marquee')) customElements.define('gr-marquee', GrMarquee);
